import React from 'react';
import ZoomableImage from './ZoomableImage';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000').replace(/\/$/, '');

// Grey head-and-shoulders, shown if a stored photo fails to load.
const NO_PHOTO = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 160"><rect width="140" height="160" fill="#f1f5f9"/><circle cx="70" cy="62" r="28" fill="#cbd5e1"/><path d="M22 160c0-30 21-50 48-50s48 20 48 50z" fill="#cbd5e1"/></svg>',
)}`;

// Stored paths are either full URLs or relative to the API host.
const photoSrc = (path: string) =>
  /^(https?:|data:)/.test(path) ? path : `${API_BASE}/${path.replace(/^\//, '')}`;

// The staff member's registration photo, at the top of the Salary Sheet
// summary panel. Click to enlarge.
const StaffPhoto: React.FC<{ path?: string | null; name: string }> = ({ path, name }) => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', backgroundColor: '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
    {path ? (
      <ZoomableImage
        src={photoSrc(path)}
        fallbackSrc={NO_PHOTO}
        alt={`${name} photo`}
        title="Click to enlarge"
        style={{ width: 140, height: 160, objectFit: 'cover', borderRadius: 8, border: '1px solid #e2e8f0' }}
      />
    ) : (
      <span style={{ fontSize: '0.74rem', color: '#94a3b8' }}>No photo on file.</span>
    )}
  </div>
);

export default StaffPhoto;
